<app-user-statistics-files kind="masters"></app-user-statistics-files>


